<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="4">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <div class="container">
                  <img class="img-responsive" src="img/logo2.png" style="width:250px;margin-bottom: 10px;margin-left: -10px;"  alt="MCSS ISIKULKAS" />
                </div>
                <b-form id="LoginForm" validated novalidate>

                  <!-- <h1>Login</h1> -->
                  <p class="text-muted">Sign In to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input id="username" type="text" v-model="$v.LoginForm.username.$model" class="form-control" placeholder="Username"/>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input id="password" type="password" v-model="$v.LoginForm.password.$model" class="form-control" placeholder="Password" />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button variant="primary" @click="submitLogin" class="px-4" :disabled="$v.LoginForm.$invalid">Login</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button variant="link" class="px-0">Forgot password?</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <!-- <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <b-card-body class="text-center">
                <div>
                  <h2>Skynet HRMS</h2>
                  <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                  <b-button variant="primary" class="active mt-3">Register Now!</b-button>
                </div>
              </b-card-body>
            </b-card> -->
          </b-card-group>
          <div>
            <div style="float:left">
              <span class="ml-1 text-muted">&copy; 2018.</span>
            </div>
            <div style="float:right" class="ml-auto">
              <span class="mr-1 text-muted">Powered by, ISIKULKAS</span>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

  import interfaces from '@/templates/_interfaces.js'
  import axios from 'axios'
  import { required, email } from 'vuelidate/lib/validators'
  import VueNotifications from 'vue-notifications'

  export default {
    name: 'Login',
    data ()  {
      return {
        LoginForm: {
          username: null,
          password: null
        }

      }
    },
    validations: {
      LoginForm: {
        username: { required },
        password: { required }
      }
    },
    notifications: {
      showErrorNotification: {
        title: 'Error Title',
        message: 'Messages',
        type: 'error'
      },
      showInfoNotification: {
        title: 'Info Title',
        message: 'Messages',
        type: 'info'
      }
    },
    watch:{
      storage(data) {
        localStorage.setItem('token', data.token)
        localStorage.setItem('employee_id', data.employee_id)
      }
    },
    methods: {
      init: function() {
      },
      submitLogin: function() {
        this.axios.post('/authentication/login/', this.LoginForm).then( (response)=> {
          if(response.data.status === 2000) {
            localStorage.setItem('token', response.data.token)
            localStorage.setItem('nik', response.data.nik)
            localStorage.setItem('employee_id', response.data.employee_id)
            localStorage.setItem('name', response.data.name)
            localStorage.setItem('division_id', response.data.division_id)
            localStorage.setItem('position_id', response.data.position_id)
            localStorage.setItem('division_name', response.data.division_name)
            localStorage.setItem('position_name', response.data.position_name)
            localStorage.setItem('start_page', response.data.start_page)
            localStorage.setItem('level', response.data.level)
            this.showInfoNotification({title: 'Login', message: response.data.message})

            // let goTo='';
            // if(["12"].includes(response.data.division_id) ) {
            //   goTo='hrd';
            // } else if(["6", "9"].includes(response.data.division_id)) {
            //   goTo='cro';
            // }else {
            //   goTo='profile';
            // }

            this.handleSubmit(response.data.start_page)
          } else {
            this.showErrorNotification({ title: 'Login', message: response.data.message })
          }
        })
        .catch(error => {
          //console.log(error)
          this.showErrorNotification({ title: 'Login', message: error.response.message })
        })
      },
      handleSubmit: function (goTo) {
        this.$router.push({ path: 'dashboard-'+goTo })
      }
    },
    mounted () {
      //this.init()
    }
  }

</script>
